module.exports = "/_next/static/images/6fb5d8f87b3e292ce47981cb0a1ad52b-roxinho-details-metalico-lg@1x.jpg.webp";